import Adicionar from './Adicionar';
import Informacoes from './Informacoes';
import Lista from './Lista';

export const TarefaAdicionar = Adicionar;
export const TarefaInformacoes = Informacoes;
export const TarefaLista = Lista;
